import store from '../store';
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'

const routes = [
    {path: '/login', component: () => import(/* webpackChunkName: 'login' */ '@/views/Login.vue')},
    {path:'/docente/register',name:'docente_register',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_register.vue'),meta:{permission:""}},
    {path:'/tecnologico/register',name:'tecnologico_register',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_register.vue'),meta:{permission:""}},
    
    { 
        path: '/dashboard',
        name: 'dashboardVacio',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
        children: [
            {path:'/',name:'dashboard',component: ()=>import(/* webpackChuckName: "beneficiario" */ '@/views/Home.vue'),meta:{permission:""}},

            {path:'/user/create',name:'user_create',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_form.vue'),meta:{permission:'add_user'}},
            {path:'/user/list',name:'user_list',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_list.vue'),meta:{permission:"view_user"}},
            {path:'/user/detail/:id',name:'user_detail',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_detail.vue'),meta:{permission:"view_user"}},
            {path:'/user/edit/:id',name:'user_edit',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_form.vue'),meta:{permission:"change_user"}},
            {path:'/user/delete/:id',name:'user_delete',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_delete.vue'),meta:{permission:"delete_user"}},
            {path:'/user/profile',name:'user_profile',component: ()=>import(/* webpackChuckName: "user" */ '@/views/admin/user/User_profile.vue')},

            {path:'/group/create',name:'group_create',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/group/Group_form.vue'),meta:{permission:"add_group"}},
            {path:'/group/list',name:'group_list',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/group/Group_list.vue'),meta:{permission:"view_group"}},
            {path:'/group/detail/:id',name:'group_detail',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/group/Group_detail.vue'),meta:{permission:"view_group"}},
            {path:'/group/edit/:id',name:'group_edit',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/group/Group_form.vue'),meta:{permission:"change_group"}},
            {path:'/group/delete/:id',name:'group_delete',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/group/Group_delete.vue'),meta:{permission:"delete_group"}},

            {path:'/system/edit',name:'system_edit',component: ()=>import(/* webpackChuckName: "group" */ '@/views/admin/system/System_form.vue'),meta:{permission:"change_settings"}},
						
            //Docente
            {path:'/docente/create',name:'docente_create',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_form.vue'),meta:{permission:2}},
            {path:'/docente/list',name:'docente_list',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_list.vue'),meta:{permission:1}},
            {path:'/docente/detail/:id',name:'docente_detail',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_detail.vue'),meta:{permission:1}},
            {path:'/docente/edit/:id',name:'docente_edit',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_form.vue'),meta:{permission:3}},
            {path:'/docente/delete/:id',name:'docente_delete',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/docente/Docente_delete.vue'),meta:{permission:4}},
						//childrens

            //Tecnologico
            {path:'/tecnologico/create',name:'tecnologico_create',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_form.vue'),meta:{permission:2}},
            {path:'/tecnologico/list',name:'tecnologico_list',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_list.vue'),meta:{permission:1}},
            {path:'/tecnologico/detail/:id',name:'tecnologico_detail',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_detail.vue'),meta:{permission:1}},
            {path:'/tecnologico/edit/:id',name:'tecnologico_edit',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_form.vue'),meta:{permission:3}},
            {path:'/tecnologico/delete/:id',name:'tecnologico_delete',component: ()=>import(/* webpackChuckName: "docente" */ '@/views/tecnologico/Tecnologico_delete.vue'),meta:{permission:4}},
        ],
        meta: { requiresAuth: true }
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


function checkVerified(to) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      return true;
    }
  } else {
    return true;
  }
}

function checkPermission(to) {
 var permissions=[
  {'id':1,'name':'Ver Docente'},
  {'id':2,'name':'Crear Docente'},
  {'id':3,'name':'Editar Docente'},
  {'id':4,'name':'Eliminar Docente'},
];
  console.log("rutaaasdfasdfasf",to.matched);
  console.log("*-****",store.state.user.permissions,store.state.isAdmin);
  if (to.matched.some(path => path.meta.permission) && !store.state.isAdmin) {
    var toFinal=to.matched.find(path => path.meta.permission);
    var allow=false;
    /*console.log("aaaaa",store.state.user);*/
    
    permissions.forEach(element => {
      //if (element.id==toFinal.meta.permission element.includes(toFinal.meta.permission)) {
      if (element.id==toFinal.meta.permission) {
        allow=true;
      }
    });
    console.log("*-****",store.state.user.permissions);
    if (store.state.user.permissions.includes(toFinal.meta.permission)) {
      return true;
    } else {
      var message="No tienes permiso para realizar esta acción.";
      var returnBack=false;
      store.commit("showError",{msg:message,returnBack:returnBack});
      return false;
    }
  } else {
    return true;
  }
}

router.beforeEach((to, from, next) => {
  if (checkVerified(to)) {
    if (checkPermission(to)) {
      next();
    }
  } else {
    next();
  }  
})
export default router
